// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-35bedb36] .ivu-modal .ivu-select-dropdown{z-index:1000}.messageList[data-v-35bedb36]{height:60%}.messageList[data-v-35bedb36] .el-scrollbar__wrap{overflow-x:hidden}[data-v-35bedb36] .ck.ck-editor__top.ck-reset_all{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
